"use client";

import { useEffect } from "react";
import { initializeAuth } from "@/stores/authStore";

interface AuthProviderProps {
  children: React.ReactNode;
}

/**
 * Auth provider that initializes authentication on app load
 * Wraps the app and fetches current user from the server
 */
export function AuthProvider({ children }: AuthProviderProps) {
  useEffect(() => {
    // Initialize auth on mount - check server for valid cookie
    initializeAuth();
  }, []);

  // Don't block rendering - let ProtectedRoute handle redirects
  return <>{children}</>;
}
